import React from 'react';
import styled from 'styled-components';

import { Button } from '@companycam/slab-web';
import { translate } from 'translations/i18n';

import { type UseProfileFormReturn } from '../useProfileForm';
import { IndustriesField } from '../FormFields/IndustriesField';
import { ServicesField } from '../FormFields/ServicesField';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cc_size_spacing_l);
`;

type CompanyInfoStepProps = {
  formMethods: UseProfileFormReturn;
};

export const CompanyInfoFooterActions = ({
  onFinish,
  isSubmitting,
  isValid,
}: {
  onFinish: () => void;
  isSubmitting: boolean;
  isValid: boolean;
}) => {
  return (
    <Button
      color="primary"
      onClick={onFinish}
      loading={isSubmitting}
      disabled={isSubmitting || !isValid}
    >
      {translate('common.publish')}
    </Button>
  );
};

export const CompanyInfoStep = ({ formMethods }: CompanyInfoStepProps) => {
  return (
    <Container>
      <ServicesField formMethods={formMethods} />
      <IndustriesField formMethods={formMethods} />
    </Container>
  );
};
